import Cookies from 'js-cookie';
const SOUND_STATE_ON = 'on';
const SOUND_STATE_OFF = 'off';

let tempSoundState =  Cookies.get('sound');

const CLASS_NAME_SOUND_ON = 'is-sound';
const CLASS_NAME_SOUND_OFF = 'is-mute';
const CLASS_NAME_SOUND_UNSET = 'is-unset';

export function applySoundCookie() {

  console.log('sound', tempSoundState);

  if(tempSoundState === SOUND_STATE_ON) {
    turnOnSound();
  } else if(tempSoundState === SOUND_STATE_OFF) {
    turnOffSound();
  } else {
    document.body.classList.add(CLASS_NAME_SOUND_UNSET);
  }
  const opening = document.querySelector('.opening__inner');
  if(opening) {
    opening.style.display = '';
  }

  window.addEventListener('blur', ()=>{fadeOutRecursive(10, 10, 100)});
  window.addEventListener('focus', ()=>{fadeInRecursive(10, 1, 100)});
}

export function toggleSound(DoSetCookie = true) {
  const body = document.body;
  if(body.classList.contains(CLASS_NAME_SOUND_ON)) {
    turnOffSound(DoSetCookie);
  } else {
    turnOnSound(DoSetCookie);
  }
}

export function turnOnSound(DoSetCookie = true) {
  console.log('tunr on sound', tempSoundState);
  if(DoSetCookie) {Cookies.set('sound', SOUND_STATE_ON)}
  tempSoundState = SOUND_STATE_ON;
  const body = document.body;
  body.classList.remove(CLASS_NAME_SOUND_OFF);
  body.classList.remove(CLASS_NAME_SOUND_UNSET);
  body.classList.add(CLASS_NAME_SOUND_ON);
  const bgAudio = document.querySelector('#bgAudio');
  if(bgAudio) {
    window.addEventListener('click', playBG);
    playBG();
  }
}

export function turnOffSound(DoSetCookie = true) {
  console.log('tunr off sound', tempSoundState);
  if(DoSetCookie) {Cookies.set('sound', SOUND_STATE_OFF)}
  tempSoundState = SOUND_STATE_OFF;
  const body = document.body;
  body.classList.remove(CLASS_NAME_SOUND_ON);
  body.classList.remove(CLASS_NAME_SOUND_UNSET);
  body.classList.add(CLASS_NAME_SOUND_OFF);
  const bgAudio = document.querySelector('#bgAudio');
  bgAudio.muted = true;
  if(bgAudio) {
    window.removeEventListener('click', playBG);
    bgAudio.pause();
  }
}

export function playSE(option = {fadeout: false, scale: 10, left: 10, delay: 100}) {// eslint-disable-line
  const effectAudio = document.querySelector('#effectAudio');
  if(effectAudio && tempSoundState === SOUND_STATE_ON) {
    effectAudio.muted = false;
    effectAudio.loop = false;
    effectAudio.play();
  }
  if(option.fadeout) fadeOutRecursive(option.scale, option.left, option.delay);
}

export function playBG() {
  const bgAudio = document.querySelector('#bgAudio');
  if(bgAudio && tempSoundState === SOUND_STATE_ON) {
    bgAudio.muted = false;
    bgAudio.play().catch(e => {
      turnOffSound(false);
      console.log('Failed to play sound. so turned off the sound.', e);
    });
  }
}

/**
 * 時間をかけて再帰的に音量を0まで数値を減らす
 * @param scale ステップの最大数
 * @param left 残りステップ数
 * @param delay ステップ実行間のディレイ
 */
function fadeOutRecursive(scale, left, delay) {
  const bgAudio = document.querySelector('#bgAudio');
  if(bgAudio) {
    if(bgAudio.volume <= 0) return;
    bgAudio.volume = left/scale;
  }
  if(left > 0) {
    window.setTimeout(()=>{fadeOutRecursive(scale, --left, delay)}, delay);
  } else {
    turnOffSound(false);
    bgAudio.mute = true;
  }
}

/**
 * 時間をかけて再帰的に音量を1まで数値を増やす
 * @param scale ステップの最大数
 * @param left 残りステップ数
 * @param delay ステップ実行間のディレイ
 */
function fadeInRecursive(scale, left, delay) {
  const bgAudio = document.querySelector('#bgAudio');
  if(bgAudio) {
    if( tempSoundState === SOUND_STATE_ON && parseFloat(bgAudio.volume) < 1) {
      turnOnSound(false);
      bgAudio.mute = false;
    } else {
      return;
    }

    bgAudio.volume = Math.min(left/scale, 1);
  }
  if(left < scale) {
    window.setTimeout(()=>{fadeInRecursive(scale, ++left, delay)}, delay);
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/_sound.js